/**
 * CHIKAS payment marquee — pixel-perfect infinite loop to the right.
 * Duplicates logo groups until the strip is always wider than the viewport.
 */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  function fillTrack(root) {
    const viewport = root.querySelector('.pay-marquee__viewport');
    const track = root.querySelector('.pay-marquee__track');
    const source = root.querySelector('.pay-marquee__group');
    if (!viewport || !track || !source) return;

    // Keep only the first real group; rebuild clones.
    [...track.querySelectorAll('.pay-marquee__group')].forEach((g, i) => {
      if (i > 0) g.remove();
    });
    source.removeAttribute('aria-hidden');

    const need = Math.max(viewport.clientWidth * 2.2, source.getBoundingClientRect().width * 2);
    let total = source.getBoundingClientRect().width;
    let guard = 0;
    while (total < need && guard < 12) {
      const clone = source.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach(img => img.alt = '');
      track.appendChild(clone);
      total += source.getBoundingClientRect().width;
      guard += 1;
    }

    const shift = source.getBoundingClientRect().width;
    track.style.setProperty('--pay-shift', `${shift}px`);
    track.style.animation = 'none';
    // Restart cleanly so duration stays constant after resize.
    void track.offsetWidth;
    if (!reduced.matches) {
      track.style.animation = '';
    }
  }

  function setup(root) {
    if (root.dataset.payReady) {
      fillTrack(root);
      return;
    }
    root.dataset.payReady = '1';
    fillTrack(root);

    const onResize = () => {
      clearTimeout(root._payResize);
      root._payResize = setTimeout(() => fillTrack(root), 140);
    };
    window.addEventListener('resize', onResize, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(() => fillTrack(root));

    document.addEventListener('visibilitychange', () => {
      const track = root.querySelector('.pay-marquee__track');
      if (track) track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    });
  }

  function mount() {
    document.querySelectorAll('.pay-marquee').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
